module.exports = __webpack_public_path__ + "static/media/ig2.ae4544dc.jpg";